// extracted by css-extract-rspack-plugin
export default {"resizing":"LMj0j","column":"Xop0K","footer":"ZmpkV","preview":"wQQmP","header":"Lf3be"};